/**
 * HUB / SÉLECTEUR DE PROJET — /univers
 * Splash de marque premium qui aiguille chaque visiteur vers son univers.
 * Thème clair, bords nets, Enso K en filigrane, logo KAIZEN rouge.
 */
import { Link } from "react-router-dom";
import { LockKey, Storefront, Ticket, GlobeHemisphereWest, ArrowUpRight, UserPlus } from "@phosphor-icons/react";

const TILES = [
  { id: "membres", title: "Espace Membres", desc: "Accès exclusif", icon: LockKey, to: "/membres", locked: true },
  { id: "boutique", title: "Boutique", desc: "Équipements & vêtements", icon: Storefront, to: "/boutique-accueil" },
  { id: "gala", title: "Gala", desc: "Événements officiels", icon: Ticket, to: "/" },
  { id: "franchise", title: "Franchise KAIZEN", desc: "Devenir partenaire", icon: GlobeHemisphereWest, to: "/franchise" },
];

export default function UniversHub() {
  return (
    <div className="kz-body min-h-screen bg-white text-[#0A0A0A] flex flex-col items-center justify-center p-6 sm:p-12 md:p-20 relative overflow-hidden" data-testid="univers-hub">
      {/* Filigrane Enso */}
      <img src="/logos/kaizen_system/generated/kaizen_system_icon_only_enso_K.png" alt=""
        className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] max-w-[760px] opacity-[0.04]" />

      {/* En-tête marque */}
      <div className="relative z-10 text-center kz-fade-up">
        <img src="/logos/kaizen_system/generated/kaizen_system_master_red_on_white.png" alt="KAIZEN SYSTEM"
          className="h-14 sm:h-16 mx-auto object-contain" data-testid="hub-logo" />
        <p className="kz-mono text-[11px] tracking-[0.28em] uppercase text-black/40 mt-5">
          KAIZEN SYSTEM · by Institut Impact Élite Martial
        </p>
        <h1 className="kz-display text-3xl sm:text-4xl font-medium mt-6 tracking-tight">Choisis ton univers</h1>
      </div>

      {/* Grille de cartes */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 w-full max-w-4xl mt-12">
        {TILES.map((t, i) => {
          const Icon = t.icon;
          return (
            <Link key={t.id} to={t.to} data-testid={`universe-card-${t.id}`}
              className="group relative h-56 md:h-64 bg-white border border-black/10 hover:border-[#D90429] transition-colors duration-500 flex flex-col justify-between p-8 overflow-hidden kz-fade-up"
              style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
              <div className="flex items-start justify-between">
                <Icon size={34} weight="light" className="text-[#0A0A0A] group-hover:text-[#D90429] transition-colors" />
                {t.locked && <span className="kz-mono text-[10px] tracking-[0.2em] uppercase text-black/40 border border-black/10 px-2 py-1">Connexion</span>}
              </div>
              <div>
                <p className="kz-mono text-[10px] tracking-[0.24em] uppercase text-black/40">{t.desc}</p>
                <div className="flex items-center justify-between mt-1">
                  <h2 className="kz-display text-2xl sm:text-3xl font-medium">{t.title}</h2>
                  <ArrowUpRight size={24} className="text-black/20 group-hover:text-[#D90429] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                </div>
              </div>
              <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#D90429] group-hover:w-full transition-all duration-500" />
            </Link>
          );
        })}
      </div>

      {/* CTA Adhésion */}
      <Link to="/adhesion" data-testid="hub-adhesion-cta"
        className="relative z-10 group mt-8 inline-flex items-center gap-3 bg-[#D90429] text-white px-7 py-4 font-bold tracking-wider hover:bg-[#0A0A0A] transition-colors kz-fade-up">
        <UserPlus size={20} weight="fill" /> Devenir membre · s'inscrire en ligne
        <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
      </Link>

      <p className="relative z-10 kz-mono text-[10px] tracking-[0.2em] uppercase text-black/30 mt-12">
        Val-d'Or · Québec · © 2026 Institut Impact Élite Martial
      </p>
    </div>
  );
}
